import { ApiService } from '../api';
import { URLS, UrlUtils } from '../urls';
import { L10nUtils } from '../../utils/l10n_utils';
const storedSettings = new Map();
export class CookiesService extends ApiService {
    getSettings(planogram) {
        const currentLang = L10nUtils.getCurrentLanguage();
        const settings = CookiesService.getSettings(currentLang);
        const url = UrlUtils.insertFewValuesToUrl(URLS.COOKIES_SETTINS, {
            lang: L10nUtils.getCurrentLanguage(),
            planogram_name: planogram.name
        });
        if (settings) {
            return Promise.resolve(settings);
        }
        return this.get(url)
            .then(resp => resp.json())
            .then(data => {
            CookiesService.setSettings(currentLang, data);
            return data;
        });
    }
    static getSettings(languageCode) {
        return storedSettings.get(languageCode);
    }
    static setSettings(languageCode, data) {
        storedSettings.set(languageCode, data);
    }
}
